const resource = {
    resource_identifier_in_use: "L'identifiant d'API {{indicator}} est déjà utilisé",
    /** UNTRANSLATED */
    cannot_delete_management_api: 'Cannot delete Logto management API.',
};
export default Object.freeze(resource);
